/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as MarketingRouteImport } from './routes/_marketing'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as AppMyLearningRouteImport } from './routes/_app.my-learning'
import { Route as AppMyPurchasesRouteImport } from './routes/_app.my-purchases'
import { Route as AppProfileRouteImport } from './routes/_app.profile'
import { Route as MarketingIndexRouteImport } from './routes/_marketing.index'
import { Route as MarketingAboutRouteImport } from './routes/_marketing.about'
import { Route as MarketingContactRouteImport } from './routes/_marketing.contact'
import { Route as MarketingCookiesRouteImport } from './routes/_marketing.cookies'
import { Route as MarketingCoursesRouteImport } from './routes/_marketing.courses'
import { Route as MarketingPrivacyRouteImport } from './routes/_marketing.privacy'
import { Route as MarketingRegisterRouteImport } from './routes/_marketing.register'
import { Route as MarketingTermsRouteImport } from './routes/_marketing.terms'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminAnalyticsRouteImport } from './routes/admin/analytics'
import { Route as AdminRolesRouteImport } from './routes/admin/roles'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as MarketingCoursesCourseIdRouteImport } from './routes/_marketing.courses_.$courseId'
import { Route as AdminCoursesIndexRouteImport } from './routes/admin/courses/index'
import { Route as AdminCoursesCourseIdRouteImport } from './routes/admin/courses/$courseId'
import { Route as AdminCoursesNewRouteImport } from './routes/admin/courses/new'
import { Route as LearningCoursesCourseIdPlayerRouteImport } from './routes/learning/courses/$courseId.player'
import { Route as AdminCoursesCourseIdVersionsVersionIdDraftRouteImport } from './routes/admin/courses/$courseId_.versions.$versionId.draft'
import { Route as AdminCoursesCourseIdVersionsVersionIdModulesRouteImport } from './routes/admin/courses/$courseId_.versions.$versionId.modules'
import { Route as AdminCoursesCourseIdVersionsVersionIdPreviewRouteImport } from './routes/admin/courses/$courseId_.versions.$versionId.preview'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketingRoute = MarketingRouteImport.update({
  id: '/_marketing',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppMyLearningRoute = AppMyLearningRouteImport.update({
  id: '/my-learning',
  path: '/my-learning',
  getParentRoute: () => AppRoute,
} as any)
const AppMyPurchasesRoute = AppMyPurchasesRouteImport.update({
  id: '/my-purchases',
  path: '/my-purchases',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const MarketingIndexRoute = MarketingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingAboutRoute = MarketingAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingContactRoute = MarketingContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingCookiesRoute = MarketingCookiesRouteImport.update({
  id: '/cookies',
  path: '/cookies',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingCoursesRoute = MarketingCoursesRouteImport.update({
  id: '/courses',
  path: '/courses',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingPrivacyRoute = MarketingPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingRegisterRoute = MarketingRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingTermsRoute = MarketingTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => MarketingRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
  id: '/admin/analytics',
  path: '/admin/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRolesRoute = AdminRolesRouteImport.update({
  id: '/admin/roles',
  path: '/admin/roles',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketingCoursesCourseIdRoute =
  MarketingCoursesCourseIdRouteImport.update({
    id: '/courses_/$courseId',
    path: '/courses/$courseId',
    getParentRoute: () => MarketingRoute,
  } as any)
const AdminCoursesIndexRoute = AdminCoursesIndexRouteImport.update({
  id: '/admin/courses/',
  path: '/admin/courses/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCoursesCourseIdRoute = AdminCoursesCourseIdRouteImport.update({
  id: '/admin/courses/$courseId',
  path: '/admin/courses/$courseId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCoursesNewRoute = AdminCoursesNewRouteImport.update({
  id: '/admin/courses/new',
  path: '/admin/courses/new',
  getParentRoute: () => rootRouteImport,
} as any)
const LearningCoursesCourseIdPlayerRoute =
  LearningCoursesCourseIdPlayerRouteImport.update({
    id: '/learning/courses/$courseId/player',
    path: '/learning/courses/$courseId/player',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminCoursesCourseIdVersionsVersionIdDraftRoute =
  AdminCoursesCourseIdVersionsVersionIdDraftRouteImport.update({
    id: '/admin/courses/$courseId_/versions/$versionId/draft',
    path: '/admin/courses/$courseId/versions/$versionId/draft',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminCoursesCourseIdVersionsVersionIdModulesRoute =
  AdminCoursesCourseIdVersionsVersionIdModulesRouteImport.update({
    id: '/admin/courses/$courseId_/versions/$versionId/modules',
    path: '/admin/courses/$courseId/versions/$versionId/modules',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminCoursesCourseIdVersionsVersionIdPreviewRoute =
  AdminCoursesCourseIdVersionsVersionIdPreviewRouteImport.update({
    id: '/admin/courses/$courseId_/versions/$versionId/preview',
    path: '/admin/courses/$courseId/versions/$versionId/preview',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof MarketingIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/my-learning': typeof AppMyLearningRoute
  '/my-purchases': typeof AppMyPurchasesRoute
  '/profile': typeof AppProfileRoute
  '/about': typeof MarketingAboutRoute
  '/contact': typeof MarketingContactRoute
  '/cookies': typeof MarketingCookiesRoute
  '/courses': typeof MarketingCoursesRoute
  '/privacy': typeof MarketingPrivacyRoute
  '/register': typeof MarketingRegisterRoute
  '/terms': typeof MarketingTermsRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/admin/': typeof AdminIndexRoute
  '/courses/$courseId': typeof MarketingCoursesCourseIdRoute
  '/admin/courses/$courseId': typeof AdminCoursesCourseIdRoute
  '/admin/courses/new': typeof AdminCoursesNewRoute
  '/admin/courses/': typeof AdminCoursesIndexRoute
  '/learning/courses/$courseId/player': typeof LearningCoursesCourseIdPlayerRoute
  '/admin/courses/$courseId/versions/$versionId/draft': typeof AdminCoursesCourseIdVersionsVersionIdDraftRoute
  '/admin/courses/$courseId/versions/$versionId/modules': typeof AdminCoursesCourseIdVersionsVersionIdModulesRoute
  '/admin/courses/$courseId/versions/$versionId/preview': typeof AdminCoursesCourseIdVersionsVersionIdPreviewRoute
}
export interface FileRoutesByTo {
  '/': typeof MarketingIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/my-learning': typeof AppMyLearningRoute
  '/my-purchases': typeof AppMyPurchasesRoute
  '/profile': typeof AppProfileRoute
  '/about': typeof MarketingAboutRoute
  '/contact': typeof MarketingContactRoute
  '/cookies': typeof MarketingCookiesRoute
  '/courses': typeof MarketingCoursesRoute
  '/privacy': typeof MarketingPrivacyRoute
  '/register': typeof MarketingRegisterRoute
  '/terms': typeof MarketingTermsRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/admin': typeof AdminIndexRoute
  '/courses/$courseId': typeof MarketingCoursesCourseIdRoute
  '/admin/courses/$courseId': typeof AdminCoursesCourseIdRoute
  '/admin/courses/new': typeof AdminCoursesNewRoute
  '/admin/courses': typeof AdminCoursesIndexRoute
  '/learning/courses/$courseId/player': typeof LearningCoursesCourseIdPlayerRoute
  '/admin/courses/$courseId/versions/$versionId/draft': typeof AdminCoursesCourseIdVersionsVersionIdDraftRoute
  '/admin/courses/$courseId/versions/$versionId/modules': typeof AdminCoursesCourseIdVersionsVersionIdModulesRoute
  '/admin/courses/$courseId/versions/$versionId/preview': typeof AdminCoursesCourseIdVersionsVersionIdPreviewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_marketing': typeof MarketingRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_app/my-learning': typeof AppMyLearningRoute
  '/_app/my-purchases': typeof AppMyPurchasesRoute
  '/_app/profile': typeof AppProfileRoute
  '/_marketing/about': typeof MarketingAboutRoute
  '/_marketing/contact': typeof MarketingContactRoute
  '/_marketing/cookies': typeof MarketingCookiesRoute
  '/_marketing/courses': typeof MarketingCoursesRoute
  '/_marketing/privacy': typeof MarketingPrivacyRoute
  '/_marketing/register': typeof MarketingRegisterRoute
  '/_marketing/terms': typeof MarketingTermsRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/_marketing/': typeof MarketingIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/_marketing/courses_/$courseId': typeof MarketingCoursesCourseIdRoute
  '/admin/courses/$courseId': typeof AdminCoursesCourseIdRoute
  '/admin/courses/new': typeof AdminCoursesNewRoute
  '/admin/courses/': typeof AdminCoursesIndexRoute
  '/learning/courses/$courseId/player': typeof LearningCoursesCourseIdPlayerRoute
  '/admin/courses/$courseId_/versions/$versionId/draft': typeof AdminCoursesCourseIdVersionsVersionIdDraftRoute
  '/admin/courses/$courseId_/versions/$versionId/modules': typeof AdminCoursesCourseIdVersionsVersionIdModulesRoute
  '/admin/courses/$courseId_/versions/$versionId/preview': typeof AdminCoursesCourseIdVersionsVersionIdPreviewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/my-learning'
    | '/my-purchases'
    | '/profile'
    | '/about'
    | '/contact'
    | '/cookies'
    | '/courses'
    | '/privacy'
    | '/register'
    | '/terms'
    | '/admin/analytics'
    | '/admin/roles'
    | '/admin/users'
    | '/auth/callback'
    | '/admin/'
    | '/courses/$courseId'
    | '/admin/courses/$courseId'
    | '/admin/courses/new'
    | '/admin/courses/'
    | '/learning/courses/$courseId/player'
    | '/admin/courses/$courseId/versions/$versionId/draft'
    | '/admin/courses/$courseId/versions/$versionId/modules'
    | '/admin/courses/$courseId/versions/$versionId/preview'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/my-learning'
    | '/my-purchases'
    | '/profile'
    | '/about'
    | '/contact'
    | '/cookies'
    | '/courses'
    | '/privacy'
    | '/register'
    | '/terms'
    | '/admin/analytics'
    | '/admin/roles'
    | '/admin/users'
    | '/auth/callback'
    | '/admin'
    | '/courses/$courseId'
    | '/admin/courses/$courseId'
    | '/admin/courses/new'
    | '/admin/courses'
    | '/learning/courses/$courseId/player'
    | '/admin/courses/$courseId/versions/$versionId/draft'
    | '/admin/courses/$courseId/versions/$versionId/modules'
    | '/admin/courses/$courseId/versions/$versionId/preview'
  id:
    | '__root__'
    | '/_app'
    | '/_marketing'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/_app/my-learning'
    | '/_app/my-purchases'
    | '/_app/profile'
    | '/_marketing/about'
    | '/_marketing/contact'
    | '/_marketing/cookies'
    | '/_marketing/courses'
    | '/_marketing/privacy'
    | '/_marketing/register'
    | '/_marketing/terms'
    | '/admin/analytics'
    | '/admin/roles'
    | '/admin/users'
    | '/auth/callback'
    | '/_marketing/'
    | '/admin/'
    | '/_marketing/courses_/$courseId'
    | '/admin/courses/$courseId'
    | '/admin/courses/new'
    | '/admin/courses/'
    | '/learning/courses/$courseId/player'
    | '/admin/courses/$courseId_/versions/$versionId/draft'
    | '/admin/courses/$courseId_/versions/$versionId/modules'
    | '/admin/courses/$courseId_/versions/$versionId/preview'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  MarketingRoute: typeof MarketingRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  AdminAnalyticsRoute: typeof AdminAnalyticsRoute
  AdminRolesRoute: typeof AdminRolesRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminCoursesCourseIdRoute: typeof AdminCoursesCourseIdRoute
  AdminCoursesNewRoute: typeof AdminCoursesNewRoute
  AdminCoursesIndexRoute: typeof AdminCoursesIndexRoute
  LearningCoursesCourseIdPlayerRoute: typeof LearningCoursesCourseIdPlayerRoute
  AdminCoursesCourseIdVersionsVersionIdDraftRoute: typeof AdminCoursesCourseIdVersionsVersionIdDraftRoute
  AdminCoursesCourseIdVersionsVersionIdModulesRoute: typeof AdminCoursesCourseIdVersionsVersionIdModulesRoute
  AdminCoursesCourseIdVersionsVersionIdPreviewRoute: typeof AdminCoursesCourseIdVersionsVersionIdPreviewRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_marketing': {
      id: '/_marketing'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof MarketingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/my-learning': {
      id: '/_app/my-learning'
      path: '/my-learning'
      fullPath: '/my-learning'
      preLoaderRoute: typeof AppMyLearningRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my-purchases': {
      id: '/_app/my-purchases'
      path: '/my-purchases'
      fullPath: '/my-purchases'
      preLoaderRoute: typeof AppMyPurchasesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_marketing/': {
      id: '/_marketing/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof MarketingIndexRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/about': {
      id: '/_marketing/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof MarketingAboutRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/contact': {
      id: '/_marketing/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof MarketingContactRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/cookies': {
      id: '/_marketing/cookies'
      path: '/cookies'
      fullPath: '/cookies'
      preLoaderRoute: typeof MarketingCookiesRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/courses': {
      id: '/_marketing/courses'
      path: '/courses'
      fullPath: '/courses'
      preLoaderRoute: typeof MarketingCoursesRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/privacy': {
      id: '/_marketing/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof MarketingPrivacyRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/register': {
      id: '/_marketing/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof MarketingRegisterRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/terms': {
      id: '/_marketing/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof MarketingTermsRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/analytics': {
      id: '/admin/analytics'
      path: '/admin/analytics'
      fullPath: '/admin/analytics'
      preLoaderRoute: typeof AdminAnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/roles': {
      id: '/admin/roles'
      path: '/admin/roles'
      fullPath: '/admin/roles'
      preLoaderRoute: typeof AdminRolesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_marketing/courses_/$courseId': {
      id: '/_marketing/courses_/$courseId'
      path: '/courses/$courseId'
      fullPath: '/courses/$courseId'
      preLoaderRoute: typeof MarketingCoursesCourseIdRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/admin/courses/': {
      id: '/admin/courses/'
      path: '/admin/courses'
      fullPath: '/admin/courses/'
      preLoaderRoute: typeof AdminCoursesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/courses/$courseId': {
      id: '/admin/courses/$courseId'
      path: '/admin/courses/$courseId'
      fullPath: '/admin/courses/$courseId'
      preLoaderRoute: typeof AdminCoursesCourseIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/courses/new': {
      id: '/admin/courses/new'
      path: '/admin/courses/new'
      fullPath: '/admin/courses/new'
      preLoaderRoute: typeof AdminCoursesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/learning/courses/$courseId/player': {
      id: '/learning/courses/$courseId/player'
      path: '/learning/courses/$courseId/player'
      fullPath: '/learning/courses/$courseId/player'
      preLoaderRoute: typeof LearningCoursesCourseIdPlayerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/courses/$courseId_/versions/$versionId/draft': {
      id: '/admin/courses/$courseId_/versions/$versionId/draft'
      path: '/admin/courses/$courseId/versions/$versionId/draft'
      fullPath: '/admin/courses/$courseId/versions/$versionId/draft'
      preLoaderRoute: typeof AdminCoursesCourseIdVersionsVersionIdDraftRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/courses/$courseId_/versions/$versionId/modules': {
      id: '/admin/courses/$courseId_/versions/$versionId/modules'
      path: '/admin/courses/$courseId/versions/$versionId/modules'
      fullPath: '/admin/courses/$courseId/versions/$versionId/modules'
      preLoaderRoute: typeof AdminCoursesCourseIdVersionsVersionIdModulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/courses/$courseId_/versions/$versionId/preview': {
      id: '/admin/courses/$courseId_/versions/$versionId/preview'
      path: '/admin/courses/$courseId/versions/$versionId/preview'
      fullPath: '/admin/courses/$courseId/versions/$versionId/preview'
      preLoaderRoute: typeof AdminCoursesCourseIdVersionsVersionIdPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AppRouteChildren {
  AppMyLearningRoute: typeof AppMyLearningRoute
  AppMyPurchasesRoute: typeof AppMyPurchasesRoute
  AppProfileRoute: typeof AppProfileRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppMyLearningRoute: AppMyLearningRoute,
  AppMyPurchasesRoute: AppMyPurchasesRoute,
  AppProfileRoute: AppProfileRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface MarketingRouteChildren {
  MarketingAboutRoute: typeof MarketingAboutRoute
  MarketingContactRoute: typeof MarketingContactRoute
  MarketingCookiesRoute: typeof MarketingCookiesRoute
  MarketingCoursesRoute: typeof MarketingCoursesRoute
  MarketingPrivacyRoute: typeof MarketingPrivacyRoute
  MarketingRegisterRoute: typeof MarketingRegisterRoute
  MarketingTermsRoute: typeof MarketingTermsRoute
  MarketingIndexRoute: typeof MarketingIndexRoute
  MarketingCoursesCourseIdRoute: typeof MarketingCoursesCourseIdRoute
}

const MarketingRouteChildren: MarketingRouteChildren = {
  MarketingAboutRoute: MarketingAboutRoute,
  MarketingContactRoute: MarketingContactRoute,
  MarketingCookiesRoute: MarketingCookiesRoute,
  MarketingCoursesRoute: MarketingCoursesRoute,
  MarketingPrivacyRoute: MarketingPrivacyRoute,
  MarketingRegisterRoute: MarketingRegisterRoute,
  MarketingTermsRoute: MarketingTermsRoute,
  MarketingIndexRoute: MarketingIndexRoute,
  MarketingCoursesCourseIdRoute: MarketingCoursesCourseIdRoute,
}

const MarketingRouteWithChildren = MarketingRoute._addFileChildren(
  MarketingRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  MarketingRoute: MarketingRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  AdminAnalyticsRoute: AdminAnalyticsRoute,
  AdminRolesRoute: AdminRolesRoute,
  AdminUsersRoute: AdminUsersRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminCoursesCourseIdRoute: AdminCoursesCourseIdRoute,
  AdminCoursesNewRoute: AdminCoursesNewRoute,
  AdminCoursesIndexRoute: AdminCoursesIndexRoute,
  LearningCoursesCourseIdPlayerRoute: LearningCoursesCourseIdPlayerRoute,
  AdminCoursesCourseIdVersionsVersionIdDraftRoute:
    AdminCoursesCourseIdVersionsVersionIdDraftRoute,
  AdminCoursesCourseIdVersionsVersionIdModulesRoute:
    AdminCoursesCourseIdVersionsVersionIdModulesRoute,
  AdminCoursesCourseIdVersionsVersionIdPreviewRoute:
    AdminCoursesCourseIdVersionsVersionIdPreviewRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
